<template lang="pug">
  #grid
    v-container(fluid grid-list-xs)
      v-layout(row, wrap d-flex justify-center)
        v-flex(xs12 sm10)
          v-layout.pb-5(row, wrap)
            v-flex.pa-1(xs12, sm6, v-for="(report, index) in reports", v-bind:key="index")
              Card(:report="report")
            v-flex.pa-3(xs12, v-if="reports.length <= 0")
              p.empty.text-xs-center No se encontraron reportes con los criterios de búsqueda
</template>

<script>
import Card from "@/components/Card.vue";

export default {
  name: "Grid",
  components: {
    Card
  },
  computed: {
    reports() {
      return this.$store.state.reports.filter(r => {
        return r.marker.length > 0;
      });
    }
  }
};
</script>

<style scoped lang="scss">
#grid {
  .empty {
    color: white;
    font-size: 19px;
  }
}
</style>
